import type { SearchableSelectOption } from "@/components/ui/searchable-select";

export function buildStaffOrVendorPayeeOptions(
  doctors: Array<{ id: string; name: string }>,
  vendorNames: string[],
  customVendor?: string
): SearchableSelectOption[] {
  const options: SearchableSelectOption[] = doctors.map((doctor) => ({
    value: `staff:${doctor.id}`,
    label: doctor.name,
    searchText: doctor.name,
  }));

  for (const name of vendorNames) {
    const trimmed = String(name || "").trim();
    if (!trimmed) continue;
    const hasDoctor = doctors.some(
      (doctor) => String(doctor.name || "").trim().toLowerCase() === trimmed.toLowerCase()
    );
    if (!hasDoctor) {
      options.push({
        value: `name:${trimmed}`,
        label: trimmed,
        searchText: trimmed,
      });
    }
  }

  const custom = customVendor?.trim();
  if (
    custom &&
    !vendorNames.includes(custom) &&
    !options.some((option) => option.label.toLowerCase() === custom.toLowerCase())
  ) {
    options.push({
      value: `name:${custom}`,
      label: `Add: ${custom}`,
      searchText: custom,
    });
  }

  return options.sort((a, b) => a.label.localeCompare(b.label, "en", { sensitivity: "base" }));
}
